import React, { useCallback, useEffect, useState } from "react";
import { useForm, useWatch } from "react-hook-form";

import GenericInputField, {
  TYPES,
} from "../../genericInputFields/genericInputField";
import useAppContext from "../../../hooks/useAppContext";

import {
  StyledButton,
  StyledForm,
  StyledWrapper,
} from "./impersonationForm.style";

const ImpersonationForm = () => {
  const { axios } = useAppContext();
  const [submitDisabled, setSubmitDisabled] = useState(false);
  const {
    control,
    formState: { errors },
    register,
    setError,
  } = useForm({
    defaultValues: {
      email: "",
    },
    mode: "onChange",
  });

  const fields = useWatch({ control });

  useEffect(() => {
    setSubmitDisabled(fields?.email.length < 1);
  }, [fields]);

  const handleSubmit = useCallback(() => {
    axios
      .post("/accounts/admin_login_as", {
        email: fields?.email,
      })
      .then((res) => {
        if (res.data.data.status == "failure") {
          Object.entries(res.data.data.errors).forEach(([item, error]) => {
            setError(item, error);
          });
        } else {
          window.location.assign("/");
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }, [fields]);

  return (
    <StyledWrapper>
      <StyledForm
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}
      >
        <div className="form-text">
          <div className="form-title">User impersonation</div>
          <div className="form-description">
            Enter a user&apos;s email to impersonate their account.
          </div>
        </div>

        <div className="form-input">
          <GenericInputField
            error={errors?.email}
            name="email"
            placeholder="Enter user's email"
            register={register}
            required={true}
            type={TYPES.SIMPLE_TEXT}
          />
        </div>

        <div className="form-action">
          <StyledButton disabled={submitDisabled} type="submit">
            Login as user
          </StyledButton>
        </div>
      </StyledForm>
    </StyledWrapper>
  );
};

export default ImpersonationForm;
